import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../../services/api';
import toast from 'react-hot-toast';
import Footer from '../Layout/Footer';

const Register = () => {
  const [signupMethod, setSignupMethod] = useState('email');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }

    if (signupMethod === 'email' && !email) {
      toast.error('Email is required');
      return;
    }

    if (signupMethod === 'phone' && !phone) {
      toast.error('Phone number is required');
      return;
    }

    setLoading(true);

    const payload = {
      password,
      signupMethod,
      ...(signupMethod === 'email' ? { email } : { phone }),
    };

    try {
      const response = await register(payload);
      if (response.data.success) {
        if (signupMethod === 'phone') {
          sessionStorage.setItem('verification_phone', phone);
          sessionStorage.setItem('temp_user_id', response.data.userId);
          navigate('/verify-phone');
        } else {
          toast.success('Verification email sent! Please check your inbox.');
          setTimeout(() => navigate('/login'), 3000);
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="auth-page">
        <div className="auth-shell">
          <div className="auth-side">
            <div className="auth-brand-badge">Coinspire</div>
            <h1 className="auth-title">Create your account</h1>
            <p className="auth-description">
              Start your trading journey with a secure account and access your portfolio, activity, and performance tools.
            </p>

            <div className="auth-feature-list">
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Fast account setup</span>
              </div>
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Secure email or phone verification</span>
              </div>
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Access your trading dashboard instantly</span>
              </div>
            </div>
          </div>

          <div className="auth-card">
            <div className="auth-card-header">
              <p className="auth-kicker">Sign Up</p>
              <h2 className="auth-card-title">Open your Coinspire account</h2>
              <p className="auth-card-subtitle">
                Choose how you want to register, then create your password to continue.
              </p>
            </div>

            <form onSubmit={handleRegister} className="auth-form">
              <div className="auth-field">
                <label className="auth-label">Sign up with</label>
                <div className="auth-toggle-row">
                  <button
                    type="button"
                    onClick={() => setSignupMethod('email')}
                    className={`auth-toggle-btn ${signupMethod === 'email' ? 'active' : ''}`}
                    disabled={loading}
                  >
                    Email
                  </button>
                  <button
                    type="button"
                    onClick={() => setSignupMethod('phone')}
                    className={`auth-toggle-btn ${signupMethod === 'phone' ? 'active' : ''}`}
                    disabled={loading}
                  >
                    Phone
                  </button>
                </div>
              </div>

              {signupMethod === 'email' ? (
                <div className="auth-field">
                  <label className="auth-label">Email Address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="auth-input"
                    placeholder="you@example.com"
                    disabled={loading}
                  />
                </div>
              ) : (
                <div className="auth-field">
                  <label className="auth-label">Phone Number</label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="auth-input"
                    placeholder="+1234567890"
                    disabled={loading}
                  />
                  <p className="auth-helper-text">Include country code, for example +1 for US</p>
                </div>
              )}

              <div className="auth-field">
                <label className="auth-label">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="auth-input"
                  placeholder="Minimum 8 characters"
                  disabled={loading}
                />
              </div>

              <div className="auth-field">
                <label className="auth-label">Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="auth-input"
                  placeholder="Confirm your password"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? 'Creating Account...' : 'Create Account'}
              </button>
            </form>

            <p className="auth-footer-text">
              Already have an account?{' '}
              <Link to="/login" className="auth-footer-link">
                Login
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;